const wordForms = {
    'common.importSection.record': {
        singular: 'common.importSection.record',
        plural: 'common.importSection.records',
        genitive: 'common.importSection.recordsGenitive',
    },
    'common.importSection.device': {
        singular: 'common.importSection.device',
        plural: 'common.importSection.devices',
        genitive: 'common.importSection.devicesGenitive',
    },
};

export const pluralizeWord = (count, wordKey, translate) => {
    const n = Math.abs(count);
    const forms = wordForms[wordKey];

    if (!forms) {
        console.warn(`No plural forms defined for word key: ${wordKey}`);
        return translate ? translate(wordKey) : wordKey;
    }

    if (n === 1) return translate(forms.singular);

    if (Number.isInteger(n)) {
        const last = n % 10;
        const lastTwo = n % 100;
        if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) {
            return translate(forms.plural);
        }
    }

    return translate(forms.genitive);
};
